import React, { useMemo } from "react";
import { Button, Space, Dropdown } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  TeamOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  DollarOutlined,
  BankOutlined,
  FileTextOutlined,
  DownOutlined,
  ScheduleOutlined
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../Auth/authSelectors";

export default function ShortcutBar({ isEmployee, isAdminUser, hasRouteAccess }) {
 
  const navigate = useNavigate();

  const authInfo = useSelector(selectAuthInfo);

  const accessList =
    authInfo?.company_user_access?.map((x) => x.access) || [];

    // console.log(accessList)

  const shortcuts = [

    {
      key: "attendance_overview",
      label: "Mark Attendance",
      value: "attendance_overview",
      path: isAdminUser ? "/hrpayroll/attendance" : "/hrpayroll/attendance-overview",
      icon: <FileTextOutlined />,
    },
    {
      key: "attendance_entry",
      label: "Attendance",
      value: "attendance_entry",
      path: "/hrpayroll/attendance",
      icon: <ScheduleOutlined />,
    },

    {
      key: "onboarding",
      label: "Onboarding",
      value: "onboarding",
      icon: <TeamOutlined />,
      path: "/hrpayroll/onboarding"
    },
    {
      key: "employee_entry",
      label: "Employees",
      value: "employee_entry",
      icon: <TeamOutlined />,
      path: "/hrpayroll/employees"
    },
    ...(isAdminUser || hasRouteAccess ? [{
      key: "work_routes",
      label: "Work Routes",
      value: "work_routes",
      icon: <TeamOutlined />,
      path: "/hrpayroll/work-routes"
    }]:[]),

    {
      key: "department_entry",
      label: "Departments",
      value: "department_entry",
      icon: <ApartmentOutlined />,
      path: "/hrpayroll/departments"
    },

    {
      key: "designation_entry",
      label: "Designations",
      value: "designation_entry",
      icon: <SolutionOutlined />,
      path: "/hrpayroll/designations"
    },

    {
      key: "clients_entry",
      label: "Clients",
      value: "clients_entry",
      icon: <UserOutlined />,
      path: "/hrpayroll/clients-entry"
    },

    {
      key: "salary_payment",
      label: "Salary",
      value: "salary_payment",
      icon: <DollarOutlined />,
      path: "/hrpayroll/salary-payments"
    },

    {
      key: "salary_report",
      label: "Salary Reports",
      value: "salary_report",
      icon: <FileTextOutlined />,
      path: "/hrpayroll/salary-report"
    },

    {
      key: "hrlocation",
      label: "Branch Location",
      value: "hrlocation",
      icon: <BankOutlined />,
      path: "/hrpayroll/hrlocation"
    }

  ];

  // const filteredShortcuts = useMemo(() => {

  //   return shortcuts.filter(
  //     menu => accessList.includes(menu.value)
  //   );

  // }, [accessList]);

  const filteredShortcuts = useMemo(() => {
    return shortcuts.filter((menu) => {
      if (menu.value === "work_routes" && hasRouteAccess) {
        return true;
      }

      return accessList.includes(menu.value);
    });
  }, [accessList, hasRouteAccess, shortcuts]);

  const topShortcuts =
    filteredShortcuts.length > 5
      ? filteredShortcuts.slice(0, 5)
      : filteredShortcuts;

  const topShortcutKeys = topShortcuts.map(s => s.key);

  const moreItems = filteredShortcuts
    .filter(s => !topShortcutKeys.includes(s.key))
    .map(s => ({

      key: s.key,

      label: (
        <Space>
          {s.icon}
          {s.label}
        </Space>
      ),

      onClick: () => navigate(s.path)

    }));

  return (

    <div className="shortcut-bar">

      <div className="shortcut-buttons">

        {/* Mark Attendance */}

        {/* {isEmployee && (

          <Button
            type="primary"
            icon={<CalendarOutlined />}
            onClick={() => navigate("/hrpayroll/attendance-overview?markAttendance=1")}
          >
            Mark Attendance
          </Button>

        )} */}

        {/* main shortcuts */}

        {topShortcuts.map((s, index) => (

          <Button
            key={s.key}
            type={index == 0 ? "primary" : ""}
            icon={s.icon}
            onClick={() => navigate(s.path)}
          >

            {s.label}

          </Button>

        ))}

        {/* More dropdown */}

        {moreItems.length > 0 && (

          <Dropdown
            menu={{ items: moreItems }}
            placement="bottomLeft"
          >

            <Button>

              More <DownOutlined />

            </Button>

          </Dropdown>

        )}

      </div>

    </div>

  );

}